/**
 * 展示图片
 * @param image 
 * @returns 
 */
export const getImageUrl = (image: string) => {
    return image ? `data:image/png;base64,${image}` : ''
}
